import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const MainCopyright = ({ contents }) => {
  const scrollToTarget = (v_target) => {
    var target = document.getElementById(v_target);
    window.scrollTo({
      top: target.offsetTop - 125,
      behavior: 'smooth'
    });
  }

  return (
    <footer id="footer" className="pt-4 pb-4 bg-color-dark text-white">
      <Container>
        <Row>
          <Col className="text-center text-white">
            &copy;2025 PT & Associates. All Rights Reserved | 
            <Link to={'/Disclaimer'} className='ms-1 text-white text-decoration-none'>Disclaimer</Link> | 
            <Link to={'/LegalNotice'} className='ms-1 text-white text-decoration-none'>Legal Notice</Link>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default MainCopyright